import { Routes, Route } from '@angular/router';
import { redirectLoggedIn, redirectToLogin } from './permissions.guard';
import { environment } from 'src/environments/environment';

// Route components
import { AuthComponent } from './auth/auth.component';
import { ProfileComponent } from './profile/profile.component';
import { SetOrganisationComponent } from './set-organisation/set-organisation.component';
import { PayComponent } from './pay/pay.component';
import { PayLandingComponent } from './pay-landing/pay-landing.component';
import { FirstTimeComponent } from './first-time/first-time.component';

interface AppRoutes {
  [routeKey: string]: Route;
}

const allRoutes: AppRoutes = {
  set: {
    path: 'set/:orgId',
    component: SetOrganisationComponent,
  },
  auth: {
    path: 'auth',
    component: AuthComponent,
    canActivate: [redirectLoggedIn],
    data: { view: 'start' },
    children: [
      {
        path: 'login',
        component: AuthComponent,
        data: { view: 'login' },
      },
      {
        path: 'register',
        component: AuthComponent,
        data: { view: 'register' },
      },
      {
        path: 'reset-password',
        component: AuthComponent,
        data: { view: 'reset-password' },
      },
    ],
  },
  firstTime: {
    path: 'first-time',
    component: FirstTimeComponent,
    canActivate: [redirectToLogin],
    data: {},
  },
  profile: {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [redirectToLogin],
    data: {},
  },
  pay: {
    path: 'pay',
    component: PayComponent,
    canActivate: [redirectToLogin],
    data: {},
  },
  payLanding: {
    path: 'payment-landing/:orderId',
    component: PayLandingComponent,
    canActivate: [redirectToLogin],
    data: {},
  },
};

export const routes: Routes = [];

environment.routes.forEach((route) => {
  if (allRoutes[route]) {
    routes.push(allRoutes[route]);
  }
});

routes.push({
  path: '**',
  redirectTo: environment.defaultRoute.path,
  pathMatch: 'full',
});
